<div class="user_license">
  <div class="row heading-background mt-5">
    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
      <h4 (click)="showData ? hideData() : resetAll()"
        role="button"
        class="clickable-cursor">
        <span [ngClass]="showData ? 'rotated' : 'not-rotated'">
          <mat-icon class="icon-color-fix ump-expand-section-icon">chevron_right</mat-icon>
        </span>
        Assigned Licenses
      </h4>
    </div>
    @if (showData) {
      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 search-container">
        <div (change)="updateLicenseResults()" (keyup)="updateLicenseResults()">
          <input class="form-control" type="text" placeholder="Search" [(ngModel)]="licenseSearchValue">
        </div>
        <button mat-raised-button (click)="funcGetUserLicenses()" aria-label="Reset" class="btn btn-sm button-fix button-color-fix-orange">
          <mat-icon class="icon-color-fix">cached</mat-icon>
        </button>
      </div>
    }
  </div>
  @if (showData) {
    <div class="custom_small_panelbody_fix">
      <div class="row custom_panelbody_fix custom_panelbody_fix">
        @if (Response_State=== 1) {
          <div class=" pl-1">
            <ul>
              @for (item of filteredLicenseItems; track item; let even = $even) {
                <li
                  [ngClass]="{'even': even, 'odd': !even}">
                  <mat-checkbox type="checkbox" [checked]="item.isAssigned" (click)="$event.preventDefault()" style="cursor: unset" disabled>
                    {{ item.skuName }}
                  </mat-checkbox>
                </li>
              }
            </ul>
          </div>
        }
        @if (Response_State===-2) {
          <div style=" padding: 20px !important;">
            <div class="blackbg card__desc">
              @for (_ of [].constructor(4); track _) {
                <div class="card__desc-text"></div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>